import type { CityConfig } from "../city-template/types";

export const ypsilantiConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Michigan DHHS Vital Records", href: "https://www.michigan.gov/mdhhs/adult-child-serv/informedconsent/vitalrecords", description: "Official Michigan vital records office in Lansing" },
    { label: "Marriage Licenses — Washtenaw County Clerk", href: "https://www.washtenaw.org/clerk", description: "Washtenaw County Clerk — marriage license issuance" },
    { label: "Divorce Records — Washtenaw County Clerk", href: "https://www.washtenaw.org/clerk", description: "Washtenaw County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of Michigan DHHS for online vital record orders" },
  ],
  city: "Ypsilanti",
  state: "Michigan",
  stateAbbr: "MI",
  slug: "ypsilanti",
  route: "/cities/ypsilanti",
  title: "Emergency Passport Ypsilanti, MI — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Ypsilanti, Michigan — as fast as 24 hours. Fast passport renewal and new passport applications for Ypsilanti, Pittsfield, Superior, Willow Run, and all Washtenaw County residents near Eastern Michigan University. A+ BBB rated.",
  h1: "Emergency & Expedited Passport Services in Ypsilanti, MI",
  heroSubtitle: "Ypsilanti travelers — from the Eastern Michigan University campus to the historic Depot Town district to the surrounding Washtenaw County communities — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated courier service serving all of Ypsilanti and Washtenaw County.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Scenic%20aerial%20view%20of%20Ypsilanti%20Michigan%20downtown%20with%20historic%20Depot%20Town%20district%2C%20Water%20Tower%20visible%20in%20the%20background%2C%20Eastern%20Michigan%20University%20campus%20buildings%20nearby%2C%20charming%20historic%20brick%20buildings%20along%20Michigan%20Avenue%2C%20the%20Huron%20River%20greenway%2C%20lush%20green%20trees%2C%20warm%20golden%20afternoon%20sunlight%2C%20vibrant%20college%20town%20atmosphere%2C%20professional%20city%20photography%20without%20text%20or%20people&width=1800&height=700&seq=ypsilanti-hero-001&orientation=landscape",
  heroImageAlt: "Ypsilanti Michigan historic Depot Town with the Water Tower and Eastern Michigan University campus",
  geoPosition: "42.2411;-83.6129",
  geoPlacename: "Ypsilanti, Michigan",
  lastModified: "2026-06-02",
  regionalAgency: {
    name: "Detroit Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Approximately 35 minutes east of Ypsilanti via I-94",
  },
  nearbyCitiesZips: [
    { name: "Ypsilanti", zips: "48197, 48198" },
    { name: "Ann Arbor", zips: "48103, 48104, 48105, 48108, 48109, 48113" },
    { name: "Pittsfield", zips: "48197, 48108" },
    { name: "Superior", zips: "48198" },
    { name: "Willow Run", zips: "48198" },
    { name: "Canton", zips: "48187, 48188" },
    { name: "Saline", zips: "48176" },
    { name: "Milan", zips: "48160" },
    { name: "Belleville", zips: "48111, 48112" },
    { name: "Dexter", zips: "48130" },
    { name: "Chelsea", zips: "48118" },
    { name: "Whitmore Lake", zips: "48189" },
    { name: "Manchester", zips: "48158" },
    { name: "Clinton", zips: "49236" },
    { name: "Tecumseh", zips: "49286" },
    { name: "Dundee", zips: "48131" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier to Detroit — only 35 minutes from Ypsilanti" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-building-line", title: "College Town Hub", desc: "Serving EMU students, Ann Arbor faculty, and Washtenaw County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels — ship from any Ypsilanti or Ann Arbor UPS or FedEx" },
  ],
  internalLinks: [
    { name: "Expedited passport in Ann Arbor, MI", route: "/ann-arbor" },
    { name: "Emergency passport help in Detroit, MI", route: "/cities/detroit" },
    { name: "Urgent passport services in Canton, MI", route: "/cities/canton-mi" },
    { name: "Michigan passport services overview", route: "/states/michigan" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Ypsilanti, Michigan remotely via secure registered courier. Our registered couriers hand-deliver your documents to the Detroit Passport Agency (only 35 minutes east via I-94) — the closest regional passport agency to Ypsilanti. Ypsilanti residents can ship from any UPS or FedEx in Washtenaw County.",
  fpcOfficeDistance: "Serving Ypsilanti, Ann Arbor, Pittsfield, Superior, Willow Run, Canton, Saline, Milan, Belleville, Dexter, Chelsea, Whitmore Lake, Manchester, and all of Washtenaw County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Ypsilanti and Washtenaw County. From the Eastern Michigan University campus to the historic Depot Town district, from the Pittsfield and Superior townships to the surrounding Ann Arbor metro communities — we serve all of Ypsilanti and beyond.",
  nearbyCitiesIntro: "We serve Ypsilanti and all nearby communities including Ann Arbor, Pittsfield, Superior, Willow Run, Canton, Saline, Milan, Belleville, Dexter, Chelsea, Whitmore Lake, Manchester, Clinton, Tecumseh, and Dundee. We also serve Wayne County and Southeast Michigan communities.",
  howItWorksIntro: "Most Ypsilanti travelers complete everything online and ship documents overnight. With Detroit only 35 minutes away via I-94, our couriers can deliver quickly to the Detroit Passport Agency — giving Ypsilanti and EMU students a real advantage.",
  mistakesIntro: "Ypsilanti is a major college town with Eastern Michigan University and close proximity to the University of Michigan, generating significant student and academic travel. Here are the most common passport mistakes we see from Washtenaw County travelers.",
  testimonialsIntro: "Ypsilanti travelers — from EMU students and faculty to Depot Town families to Ann Arbor metro professionals — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Ypsilanti, MI? Here are the most common ones we hear from Ypsilanti and Washtenaw County travelers.",
  statePageRoute: "/states/michigan",
  statePageName: "Michigan",
  dmvWebsite: "https://www.michigan.gov/sos",
  dmvLabel: "Michigan SOS — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Detroit agency — only 35 minutes from Ypsilanti", "No drive required — ship from Ypsilanti", "Perfect for EMU student and academic travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Detroit agency — closest to Ypsilanti", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 35 minutes to Detroit", "Full morning or afternoon commitment"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Ypsilanti travelers with immediate departure needs — as fast as 24 hours. Detroit is only 35 minutes away, so our couriers can deliver quickly. Perfect for last-minute study abroad and academic conference travel.",
      bullets: ["24–48 hour turnaround available", "Detroit agency — closest regional facility", "EMU student and academic travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Ypsilanti adults with a passport issued within the last 15 years. Skip the post office appointment entirely.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Washtenaw County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Ypsilanti residents and families — including EMU students, new citizens, and Washtenaw County families.",
      bullets: ["Acceptance facility scheduling", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Ypsilanti residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Ypsilanti and Washtenaw County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Ypsilanti and Washtenaw County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Ypsilanti MI", description: "Urgent passport processing for Ypsilanti Michigan travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Ypsilanti MI", description: "Fast passport renewal for Ypsilanti Michigan residents with a previously-issued passport." },
    { name: "First-Time Passport Ypsilanti MI", description: "New passport application services for Ypsilanti Michigan residents applying for their first passport." },
    { name: "Child Passport Ypsilanti MI", description: "Minor passport services for Ypsilanti Michigan families with children under 16." },
  ],
  testimonials: [
    {
      name: "Dr. Amanda R.",
      location: "Ypsilanti, MI",
      rating: 5,
      text: "Conference in Berlin in 5 days and my passport was expired. Fast Passport Center had my renewed passport in 2 days. I shipped from the UPS Store on Washtenaw and the whole process was seamless. Perfect for EMU faculty.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Chris T.",
      location: "Ypsilanti, MI",
      rating: 5,
      text: "Study abroad semester in Spain with 8 days notice. Fast Passport Center handled my first-time passport in 4 days. As an EMU student, I couldn't afford to miss my program. They saved my semester.",
      service: "Emergency First-Time Passport",
    },
    {
      name: "Jennifer L.",
      location: "Ann Arbor, MI",
      rating: 5,
      text: "Family trip to Costa Rica in 10 days. Four passports — two adult renewals and two for our kids. Done in 5 days. We shipped from FedEx on Packard and everything was perfect. Great for the Ann Arbor-Ypsilanti area.",
      service: "Family Passport Bundle",
    },
    {
      name: "David M.",
      location: "Ypsilanti, MI",
      rating: 5,
      text: "Lost my passport the week before a research trip to Japan. Fast Passport Center replaced it in 48 hours. I shipped from the downtown UPS and everything was perfect. The proximity to Detroit made all the difference.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "ypsi-1",
      name: "Ypsilanti Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1457 E Michigan Ave",
      city: "Ypsilanti",
      state: "MI",
      zip: "48198",
      phone: "(734) 482-0120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Ypsilanti, near Eastern Michigan University",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ypsilanti acceptance facility. Convenient for EMU students, Depot Town residents, and central Ypsilanti. Appointments required — book 1–2 weeks in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "ypsi-2",
      name: "Ann Arbor Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2200 S State St",
      city: "Ann Arbor",
      state: "MI",
      zip: "48104",
      phone: "(734) 761-3728",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Ann Arbor, approximately 8 miles west of Ypsilanti",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Alternative Ann Arbor facility. Convenient for University of Michigan students, faculty, and west-side Ypsilanti residents.",
      icon: "ri-mail-line",
    },
    {
      id: "ypsi-3",
      name: "Canton Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "435 S Lilley Rd",
      city: "Canton",
      state: "MI",
      zip: "48188",
      phone: "(734) 981-8800",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Canton, approximately 15 miles northeast of Ypsilanti",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Canton, Plymouth, and northern Washtenaw County. Good alternative for north-side travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "ypsi-4",
      name: "Saline Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 N Ann Arbor St",
      city: "Saline",
      state: "MI",
      zip: "48176",
      phone: "(734) 429-8011",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Saline, approximately 10 miles southwest of Ypsilanti",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Saline, Pittsfield Township, and southern Washtenaw County residents.",
      icon: "ri-mail-line",
    },
    {
      id: "ypsi-5",
      name: "Washtenaw County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "200 N Main St",
      city: "Ann Arbor",
      state: "MI",
      zip: "48104",
      phone: "(734) 222-6700",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Ann Arbor County Building",
      website: "https://www.washtenaw.org/",
      websiteLabel: "Washtenaw County",
      notes: "County Clerk passport acceptance. Extended hours compared to post office locations. Call to confirm current passport acceptance hours.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 35 minute drive to Detroit", fpc: "No — ship from Ypsilanti" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "EMU students and Ann Arbor academics often discover passport issues just before study abroad or conference travel. Routine processing takes 6–13 weeks. Start expedited service at least 6 weeks before your trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near EMU campus or downtown Ann Arbor sometimes produce photos that meet ID requirements but fail passport standards. Photos must be exactly 2x2 inches on a white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Washtenaw County acceptance facilities.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Ypsilanti and Ann Arbor Post Office appointments fill during summer and academic conference seasons. Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-road-map-line",
      title: "Assuming the Detroit Drive Is Easy",
      description: "Even though Detroit is only 35 minutes from Ypsilanti, the regional passport agency requires appointments and only handles emergencies. Our courier service is faster and more reliable than driving yourself.",
    },
    {
      icon: "ri-time-line",
      title: "Not Planning for Study Abroad Deadlines",
      description: "EMU and University of Michigan students have strict study abroad deadlines. Don't wait until the final weeks — start your passport application at least 8 weeks before your program starts.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in the Ypsilanti area or Washtenaw County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx near EMU campus or downtown Ypsilanti." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for small errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to the Detroit Passport Agency — only 35 minutes from Ypsilanti, the fastest option for you." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Ypsilanti address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Ypsilanti, MI?", a: "Fast Passport Center offers emergency passport processing in Ypsilanti, Michigan in as little as 24–48 hours. Because Ypsilanti is only 35 minutes from the Detroit Passport Agency via I-94, our couriers can deliver your documents quickly and efficiently." },
    { q: "Does Ypsilanti have its own passport agency?", a: "No — Ypsilanti does not have a regional passport agency. The nearest facility is the Detroit Passport Agency (approximately 35 minutes east via I-94). The Detroit Passport Agency is approximately 3.5 hours west. Fast Passport Center's courier service means Ypsilanti residents never need to make the drive." },
    { q: "Can I get an expedited passport in Ann Arbor, Saline, or Canton from Ypsilanti?", a: "Absolutely. Fast Passport Center serves all of Washtenaw County including Ann Arbor, Saline, Canton, Milan, Belleville, Dexter, Chelsea, and all surrounding communities. Our service works the same way everywhere in the region." },
    { q: "What airport do Ypsilanti travelers use for international flights?", a: "Ypsilanti travelers typically use Detroit Metro Airport (DTW) in Romulus, approximately 25 minutes east via I-94. DTW is a major international hub with direct flights to Europe, Asia, Mexico, and the Caribbean. Ann Arbor Municipal Airport (ARB) offers limited regional service. For larger international hubs, DTW is the primary choice. Always verify passport validity for at least 6 months past your return date." },
    { q: "Does Fast Passport Center serve EMU students?", a: "Yes. Fast Passport Center serves all of Washtenaw County including Eastern Michigan University students, faculty, and staff. We understand academic conference schedules, study abroad deadlines, and research travel needs. Our courier service is especially valuable for students who can't take a day off to drive to Detroit." },
    { q: "How much does an expedited passport cost in Ypsilanti, MI?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Ypsilanti?", a: "Walgreens, CVS, and Walmart stores throughout Ypsilanti and Ann Arbor offer passport photos. UPS Store and FedEx Office locations also provide them. The Walgreens on Washtenaw Avenue and Walmart on Whittaker Road are convenient options. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve the Willow Run area?", a: "Yes. Fast Passport Center serves all of Ypsilanti including the Willow Run area, Superior Township, Pittsfield Township, and all surrounding communities. Whether you live near the airport or in the historic districts, our service works the same way." },
  ],
  photoLocations: [
    { name: "Walgreens — Washtenaw Ypsilanti", address: "1727 Washtenaw Ave, Ypsilanti, MI 48197", hours: "Mon–Sun: 7AM–10PM" },
    { name: "Walmart — Ypsilanti Supercenter", address: "2515 Ellsworth Rd, Ypsilanti, MI 48197", hours: "Mon–Sun: 6AM–11PM" },
    { name: "UPS Store — Ypsilanti", address: "1769 Washtenaw Ave, Ypsilanti, MI 48197", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "FedEx Office — Ann Arbor", address: "375 S Main St, Ann Arbor, MI 48104", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    { name: "Michigan SOS — Ypsilanti", address: "1839 E Michigan Ave, Ypsilanti, MI 48198", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Michigan Secretary of State for driver's licenses, REAL ID, and vehicle registration. Central Ypsilanti location near EMU. Online reservations strongly recommended.", featured: true },
    { name: "Michigan SOS — Ann Arbor", address: "3535 Washtenaw Ave, Ann Arbor, MI 48104", hours: "Mon–Fri: 9:00AM–5:00PM", note: "Serves Ann Arbor, Pittsfield Township, and western Washtenaw County. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "DTW",
      name: "Detroit Metro Airport (DTW)",
      distance: "Approximately 25 minutes east of Ypsilanti via I-94",
      address: "11050 W G Rogell Dr, Detroit, MI 48242",
      note: "Primary airport for Ypsilanti and Washtenaw County. Major international hub with direct flights to Europe, Asia, Mexico, and the Caribbean. Delta Airlines hub with extensive global connections.",
      flightUrl: "https://www.metroairport.com/",
      flightLabel: "DTW Flight Info",
      featured: true,
    },
    {
      code: "ARB",
      name: "Ann Arbor Municipal Airport",
      distance: "Approximately 15 minutes west of Ypsilanti",
      address: "801 Airport Dr, Ann Arbor, MI 48108",
      note: "Regional airport for Washtenaw County. Limited commercial service with connections to larger hubs. General aviation and charter services available.",
      flightUrl: "https://www.annarborairport.com/",
      flightLabel: "ARB Flight Info",
      featured: false,
    },
    {
      code: "FNT",
      name: "Bishop International Airport (Flint)",
      distance: "Approximately 50 minutes north of Ypsilanti via US-23",
      address: "3425 W Bristol Rd, Flint, MI 48507",
      note: "Alternative regional airport for Ypsilanti travelers. Offers flights to Florida, Chicago, and Las Vegas with Allegiant, Southwest, and American Airlines.",
      flightUrl: "https://www.bishopairport.org/",
      flightLabel: "FNT Flight Info",
      featured: false,
    },
  ],
};